import { render } from "./addModuleShopVip.vue?vue&type=template&id=b823a516"
import script from "./addModuleShopVip.vue?vue&type=script&lang=js"
export * from "./addModuleShopVip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__